const ConciergeFullScreenLoading = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        height: "100dvh",
        minHeight: "-webkit-fill-available",
        backgroundColor: "#ffffff",
      }}
    >
      <style>{`@keyframes concierge-skel-pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }`}</style>

      {/* Sidebar skeleton */}
      <div
        style={{
          width: 48,
          flexShrink: 0,
          borderRight: "1px solid #f0f0f0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: 16,
          gap: 20,
        }}
      >
        <div style={{ width: 28, height: 28, backgroundColor: "#f0f0f0", borderRadius: 8, animation: "concierge-skel-pulse 1.5s ease-in-out infinite" }} />
        <div style={{ width: 28, height: 28, backgroundColor: "#f0f0f0", borderRadius: 8, animation: "concierge-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.1s" }} />
        <div style={{ width: 28, height: 28, backgroundColor: "#f0f0f0", borderRadius: 8, animation: "concierge-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.2s" }} />
      </div>

      {/* Main content skeleton */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Top spacer */}
        <div style={{ flex: 1 }} />

        {/* Center content */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 16,
            padding: 24,
          }}
        >
          {/* Icon placeholder */}
          <div style={{ width: 40, height: 40, backgroundColor: "#f0f0f0", borderRadius: 20, animation: "concierge-skel-pulse 1.5s ease-in-out infinite" }} />

          {/* Greeting line */}
          <div style={{ width: 140, height: 18, backgroundColor: "#f0f0f0", borderRadius: 9, animation: "concierge-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.05s" }} />

          {/* Main message (two lines) */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
            <div style={{ width: 320, height: 24, backgroundColor: "#f0f0f0", borderRadius: 12, animation: "concierge-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.1s" }} />
            <div style={{ width: 260, height: 24, backgroundColor: "#f0f0f0", borderRadius: 12, animation: "concierge-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.15s" }} />
          </div>

          {/* Input box placeholder */}
          <div
            style={{
              width: "100%",
              maxWidth: 560,
              height: 100,
              backgroundColor: "#f8f8f8",
              borderRadius: 16,
              border: "1px solid #f0f0f0",
              marginTop: 8,
              animation: "concierge-skel-pulse 1.5s ease-in-out infinite",
              animationDelay: "0.2s",
            }}
          />

          {/* Suggestion pills */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center", marginTop: 4 }}>
            {[180, 220, 160, 200].map((width, i) => (
              <div
                key={i}
                style={{
                  width,
                  height: 40,
                  backgroundColor: "#f8f8f8",
                  borderRadius: 20,
                  animation: "concierge-skel-pulse 1.5s ease-in-out infinite",
                  animationDelay: `${0.25 + 0.05 * i}s`,
                }}
              />
            ))}
          </div>
        </div>

        {/* Bottom spacer (slightly more to push content up) */}
        <div style={{ flex: 1.2 }} />

        {/* Footer logo placeholder */}
        <div style={{ display: "flex", justifyContent: "center", paddingBottom: 24 }}>
          <div style={{ width: 120, height: 20, backgroundColor: "#f0f0f0", borderRadius: 6, animation: "concierge-skel-pulse 1.5s ease-in-out infinite", animationDelay: "0.4s" }} />
        </div>
      </div>
    </div>
  );
};

export default ConciergeFullScreenLoading;
